import { Button } from '@/components/atoms/button'
import { ButtonVariants, ButtonSizes } from '@/types/enums'
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerProps,
  Stack,
} from '@chakra-ui/react'
import { ButtonTypes, NavigationLevels } from '@/baseComponents'
import type { MenuItem as TopMenuItem } from './navigation'

interface Props extends Omit<DrawerProps, 'children'> {
  menuItems: Array<MenuItem>
  topRightItems: Array<TopMenuItem>
  isVisible: boolean
}

type MenuItem = {
  label: string
  url?: string
}
export const MobileDrawer = ({
  menuItems,
  topRightItems,
  isVisible,
  ...drawerProps
}: Props) => {
  return (
    <Drawer placement='top' {...drawerProps} blockScrollOnMount={true}>
      <DrawerContent>
        <DrawerBody p={0}>
          <Stack direction="row" py={2} px={4} bgColor="brand.grey">
            {topRightItems.map((element: TopMenuItem, index: number) => (
              //--index as key is accepted, list is static--//
              <Button
                className='topmenuitem'
                key={'TopMenuRight' + index}
                text={element.label}
                url={element.url}
                target={element.target}
                buttonType={ButtonTypes.TextOnly}
                buttonVariant={ButtonVariants.Text}
                buttonSize={ButtonSizes.Small}
                buttonProps={{
                  fontSize: '0.875rem'
                }}
              />
            ))}
          </Stack>
          <Stack spacing={{ base: 4, lg: 10 }} p={{ base: '1.5rem 1rem', md: '2.5rem 1.5rem' }} align='stretch'>
            {menuItems.map((element: MenuItem, i: number) => (
              <Button
                className='topmenuitem'
                key={'MobileMenu' + i}
                text={element.label}
                url={element.url}
                buttonType={ButtonTypes.TextOnly}
                buttonVariant={ButtonVariants.Text}
                buttonSize={ButtonSizes.Large}
                buttonProps={{
                  fontSize: { base: '1.25rem ', md: '1.5rem' },
                }}
                navigationTrackingEventProps={{
                  navigationItem: element.label,
                  navigationLevel: NavigationLevels.Header,
                }}
              />
            ))}
          </Stack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  )
}
